import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, CircularProgress } from '@mui/material';
import { PrimaryButon } from '../../../../../components/common/button/PrimaryButon';
import { OutlineButon } from '@ui/components/common/button/OutlineButton';
import { CloseCircle } from 'iconsax-react';
import TipTapEditor from '@ui/components/common/tip-tap-editor';
import { extractBodyContent } from '@application/common/helpers/html-document-helpers';
import AssignmentApi from '@infrastructure/assignment-api';
export const GenerateContractDialog = ({ open, handleClose, onGenerate, initialContent = '' }) => {
    const [contractContent, setContractContent] = useState(() => extractBodyContent(initialContent));
    const [isPreviewLoading, setIsPreviewLoading] = useState(false);
    // Update local state when initialContent changes (when dialog reopens with existing content)
    useEffect(() => {
        if (open) {
            const templateContent = extractBodyContent(initialContent || '');
            setContractContent(templateContent);
        }
    }, [open, initialContent]);
    const handleGenerate = () => {
        if (onGenerate) {
            onGenerate(contractContent);
        }
        handleClose(true);
    };
    const handlePreview = async () => {
        if (!contractContent || contractContent.trim().length === 0) {
            return;
        }
        setIsPreviewLoading(true);
        try {
            // Use contractContent which is updated via onChange callback
            const htmlContent = contractContent;
            // Call the API to generate PDF
            const pdfBlob = await AssignmentApi.previewContract(htmlContent, 'contract_preview.pdf');
            // Create a download link and trigger download
            const url = window.URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'contract_preview.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error('Failed to generate PDF preview:', error);
            alert('Failed to generate PDF preview. Please try again.');
        }
        finally {
            setIsPreviewLoading(false);
        }
    };
    return (_jsxs(Dialog, { open: open, onClose: () => handleClose(false), maxWidth: 'lg', fullWidth: true, PaperProps: { style: { height: '100vh' } }, children: [_jsx(DialogTitle, { children: _jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(Typography, { variant: 'h6', children: "Generate Contract" }), _jsx(IconButton, { onClick: () => handleClose(false), children: _jsx(CloseCircle, {}) })] }) }), _jsx(DialogContent, { children: _jsx(Box, { sx: { mt: 2 }, children: _jsx(TipTapEditor, { value: contractContent, onChange: setContractContent, placeholder: 'Enter contract content here...' }) }) }), _jsx(DialogActions, { children: _jsxs(Box, { sx: { display: 'flex', width: '100%', gap: 1, justifyContent: 'flex-end', p: 2 }, children: [_jsx(OutlineButon, { onClick: () => handleClose(false), children: "Cancel" }), _jsxs(OutlineButon, { onClick: handlePreview, disabled: isPreviewLoading || !contractContent || contractContent.trim().length === 0, children: [isPreviewLoading && _jsx(CircularProgress, { size: 16 }), "Preview"] }), _jsx(PrimaryButon, { onClick: handleGenerate, children: "Generate Contract" })] }) })] }));
};
